import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Header, Icon, Button, Table, Label, Checkbox } from "semantic-ui-react";
import { getAppointmentsForCenter } from "services/center";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import { toast } from "react-toastify";
import WeekCalendar from "react-week-calendar";
import CustomHeaderCell from "./Custom/CustomHeaderCell";
import CustomDayCell from "./Custom/CustomDayCell";
import CustomModal from "./Custom/CustomModal";
import CustomEvent from "./Custom/CustomEvent";
import { getFullName } from "utils/displayName";

import "./Custom/custom.css";
import "./Custom/custom.less";
import "react-week-calendar/dist/style.css";

const styles = {};

const Planning = () => {
	const [startDate, setStartDate] = useState(new Date());
	const [selectedIntervals, setSelectedIntervals] = useState([]);
	const dispatch = useDispatch();
	const user = useSelector((state) => state.user);
	useEffect(() => {
		dispatch(
			getAppointmentsForCenter(moment(startDate).add(-(+moment(startDate).weekday() - 1), "days"), user?.session?.center?.id ?? user?.session?.center)
		).then((res) => {
			if (res && res.payload && res.payload.data) {
				getPlanning(res.payload.data);
			}
		});
	}, [startDate]);

	const getPlanning = (appointments) => {
		const apps = appointments.map((app) => {
			return {
				uid: app.id,
				start: moment(app._date + " " + app._time),
				end: moment(app._date + " " + app._time).add(30, "minutes"),
				acts: app.acts,
				patientName: app.patient ? getFullName(app.patient) : app.myLabId,
				patient: app.patient,
				patientMylabId: app.myLabId,
				qrCode: app.qrCode,
				folder: app.folder,
			};
		});
		setSelectedIntervals(apps);
	};

	return (
		<Grid textAlign="left" style={{ height: "100vh", width: "97%" }} verticalAlign="top">
			<Grid.Column style={{ padding: 40, height: "93vh" }}>
				<Header as="h2" color="teal" textAlign="center" style={{ backgroundColor: "rgb(0, 147, 128)", borderRadius: "4px" }}>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "baseline",
							color: "white",
							backgroundColor: "rgb(67, 179, 158)",
							padding: "10px",
							borderRadius: "4px",
						}}
					>
						<Label as="a" onClick={() => setStartDate(moment(startDate).add(-7, "days"))}>
							<Icon name="angle left" />
							Semaine précédente{" "}
						</Label>
						<div style={{ fontSize: "0.7em" }}>Rendez-vous en centre </div>
						<Label
							as="a"
							onClick={() => setStartDate(moment(startDate).add(7, "days"))}
							style={{
								display: "flex",
								alignItems: "baseline",
							}}
						>
							Semaine suivante <Icon style={{ paddingLeft: "8px" }} name="angle right" />
						</Label>
					</div>
				</Header>
				<WeekCalendar
					startTime={moment({ h: 6, m: 0 })}
					endTime={moment({ h: 18, m: 0 })}
					scaleHeaderTitle="Planning"
					numberOfDays={6}
					cellHeight={25}
					selectedIntervals={selectedIntervals}
					scaleUnit={30}
					headerCellComponent={CustomHeaderCell}
					dayCellComponent={CustomDayCell}
					modalComponent={CustomModal}
					eventComponent={CustomEvent}
					firstDay={moment(startDate).add(-(+moment(startDate).weekday() - 1), "days")}
				/>
			</Grid.Column>
		</Grid>
	);
};

export default Planning;
